enum SearchRequestSortTypeEnum {
  Relevance = 1,
  NameAscending = 2,
  NameDescending = 3,
  PriceAscending = 4,
  PriceDescending = 5,
}

export default SearchRequestSortTypeEnum;
